import {Component, OnDestroy, OnInit} from '@angular/core';
import {forkJoin, Subject, takeUntil} from 'rxjs';
import {TopeCanalService} from '../../../_services/tope-canal.service';
import {Location} from '@angular/common';
import {TopeCanal} from '../../../_models/tope-canal';
import {ActivatedRoute} from '@angular/router';
import {TopeCanalFrecuenciaService} from '../../../_services/tope-canal-frecuencia.service';
import {TopeCanalFrecuencia} from '../../../_models/tope-canal-frecuencia';
import {NavService} from '../../../_services/_nav.service';

@Component({
  selector: 'app-tope-inversion-detalle',
  templateUrl: './tope-inversion-detalle.component.html',
  styleUrl: './tope-inversion-detalle.component.css'
})
export class TopeInversionDetalleComponent implements OnInit, OnDestroy {

  // Variables para renderizado
  cargando: boolean = true;

  // Variables para mostrar datos
  tabSeleccionado = 'CAN';
  topeCanal: TopeCanal = new TopeCanal();
  idTopeCanal: string;

  // Variables para listado
  columns: any[];
  loading: boolean = true;
  listadoFrecuencias: TopeCanalFrecuencia[] = [];

  // Variables para servicios
  private destroy$ = new Subject<void>();

  constructor(private topeCanalService: TopeCanalService,
              private topeCanalFrecuenciaService: TopeCanalFrecuenciaService,
              private route: ActivatedRoute,
              private navServicio: NavService,
              private location: Location) { }

  ngOnInit() {
    this.cargaInicial();
  }

  cargarColumnas() {
    this.columns = [
      { field: 'frecuenciaPago', header: this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_FRECUENCIAPAGO' ), sort: false },
      { field: 'valorMaximo', header: this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_VALORMAXIMO' ), sort: false },
      { field: 'descripcion', header: this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_DESCRIPCION' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
    ];
  }

  cargaInicial() {
    this.idTopeCanal = this.route.snapshot.params['id'];

    if (!this.idTopeCanal) {
      this.cargando = false;
      return;
    }

    this.cargarColumnas();
    forkJoin({
      topeCanal: this.topeCanalService.obtenerPorId(this.idTopeCanal),
      frecuencias: this.topeCanalFrecuenciaService.obtenerPorIdTopeCanal(this.idTopeCanal)
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ topeCanal, frecuencias }) => {
          this.topeCanal = topeCanal;
          this.listadoFrecuencias = frecuencias;
          this.cargando = false;
          this.loading = false;
        },
        error: () => {
          this.topeCanal = null;
          this.listadoFrecuencias = [];
          this.cargando = false;
          this.loading = false;
        }
      });
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'CAN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'INT';
        break;
      }
      default: {
        break;
      }
    }
  }

  regresar() {
    this.location.back();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
